import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useLazyQuery } from '@apollo/client'
// import styles from './style.module.scss'

import { STATS } from '@graphql/series/stats.query'
import { checkPageNumberInSlug } from '@shared-submodule/utils'
import { useRouter } from 'next/router'
import useWindowSize from '@shared/hooks/windowSize'
import CurrentSeries from '@shared/components/statsCard'
import { Col, Row } from 'react-bootstrap'
import StatsTable from './statsTable'
import Slider from '@shared/components/slider'
import StatsCardTable from '@shared/components/statsCardTable'

const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })

const Stats = ({ data, seo, typeData, id, matchTypeData, statsDataBattingMostRuns, statsDataBattingHighestStrikerate, statsDataBattingHighestAverage, statsDataBowlingTopWickeTakers, statsDataBowlingBestEconomy, statsDataBowlingBestAverages }) => {
  const [width] = useWindowSize()
  const router = useRouter()
  const [lastLastName, setLastLastName] = useState('')
  useEffect(() => {
    const calculatedLastLastName = router.asPath.split('/').pop()
    setLastLastName(calculatedLastLastName)
  }, [router.asPath])
  const { slug } = checkPageNumberInSlug(router?.asPath?.split('/').filter((e) => e))
  const pageUrl = slug.join('/')

  const initCallRef = useRef(false)
  const grpTitleRef = useRef()
  const type = typeData?.fetchSeriesStatsTypes

  const changeStats = useRef({
    stats: typeData?.fetchSeriesStatsTypes[0]?._id,
    matchType: matchTypeData && matchTypeData[0]
  })

  const optionType = [
    {
      sDescription: `${'Bat'}`,
      options: typeData?.fetchSeriesStatsTypes?.filter((e) => e?.eGroupTitle === 'Bat')
    },
    {
      sDescription: `${'Bowl'}`,
      options: typeData?.fetchSeriesStatsTypes?.filter((e) => e?.eGroupTitle === 'Bwl')
    },
    {
      sDescription: `${'Team'}`,
      options: typeData?.fetchSeriesStatsTypes?.filter((e) => e?.eGroupTitle === 'Team')
    }
  ]

  const loaderRangeRef = useRef(9)
  const [getStats] = useLazyQuery(STATS)
  const changeLabels = (description) => {
    if (description === 'batting_most_runs') {
      loaderRangeRef.current = 9
    } else if (description === 'batting_most_runs_innings') {
      loaderRangeRef.current = 8
    } else if (description === 'batting_highest_strikerate') {
      loaderRangeRef.current = 7
    } else if (description === 'batting_highest_strikerate_innings') {
      loaderRangeRef.current = 7
    } else if (description === 'batting_highest_average') {
      loaderRangeRef.current = 7
    } else if (description === 'batting_most_run100') {
      loaderRangeRef.current = 7
    } else if (description === 'batting_most_run50') {
      loaderRangeRef.current = 7
    } else if (description === 'batting_most_run6') {
      loaderRangeRef.current = 6
    } else if (description === 'batting_most_run6_innings') {
      loaderRangeRef.current = 6
    } else if (description === 'batting_most_run4') {
      loaderRangeRef.current = 6
    } else if (description === 'batting_most_run4_innings') {
      loaderRangeRef.current = 6
    } else if (description === 'bowling_top_wicket_takers') {
      // Bowl
      loaderRangeRef.current = 10
    } else if (description === 'bowling_best_economy_rates') {
      loaderRangeRef.current = 9
    } else if (description === 'bowling_best_economy_rates_innings') {
      loaderRangeRef.current = 9
    } else if (description === 'bowling_best_bowling_figures') {
      loaderRangeRef.current = 8
    } else if (description === 'bowling_best_strike_rates') {
      loaderRangeRef.current = 6
    } else if (description === 'bowling_best_strike_rates_innings') {
      loaderRangeRef.current = 6
    } else if (description === 'bowling_best_averages') {
      loaderRangeRef.current = 6
    } else if (description === 'bowling_most_runs_conceded_innings') {
      loaderRangeRef.current = 8
    } else if (description === 'bowling_four_wickets') {
      loaderRangeRef.current = 7
    } else if (description === 'bowling_five_wickets') {
      loaderRangeRef.current = 7
    } else if (description === 'bowling_maidens') {
      loaderRangeRef.current = 8
    } else if (description === 'team_total_runs') {
      // Team
      loaderRangeRef.current = 6
    } else if (description === 'team_total_run100') {
      loaderRangeRef.current = 6
    } else if (description === 'team_total_run50') {
      loaderRangeRef.current = 6
    } else if (description === 'team_total_wickets') {
      loaderRangeRef.current = 6
    }
  }

  useEffect(() => {
    if (changeStats.current && initCallRef.current) {
      getStats({ variables: { input: { iSeriesId: id, _id: changeStats.current.stats, eFormat: changeStats.current.matchType } } })
    }
  }, [changeStats.current])

  useEffect(() => {
    initCallRef.current = true
  }, [])

  useLayoutEffect(() => {
    const currentRoute = router?.query?.slug[router?.query?.slug?.length - 1]
    const type = currentRoute?.replaceAll('-', '_')
    const currentItem = typeData?.fetchSeriesStatsTypes?.filter((item) => {
      const slugType = item.sSeoType || item.sType
      return slugType === type
    })
    const selected = currentItem?.length > 0 ? currentItem[0] : optionType[0]?.options[0]
    changeLabels(selected?.sType)
    grpTitleRef.current = selected?.eGroupTitle
  }, [router])

  function getCardTableData(options, pageUrl) {
    return options.map((item) => {
      const sType = item.sSeoType || item.sType
      const urlStat = `/${pageUrl}/${sType.split('_').join('-')}`
      return {
        id: item?._id,
        url: urlStat,
        description: item?.sDescription
      }
    })
  }
  const cardTableDataBat = getCardTableData(optionType[0]?.options || [], pageUrl)
  const cardTableDataBwl = getCardTableData(optionType[1]?.options || [], pageUrl)
  const cardTableDataAll = getCardTableData(optionType[2]?.options || [], pageUrl)

  return (
    <>
      {lastLastName === 'stats' ? (
        <>
          {type?.length !== 0 ? (
            <>

              <h3 className='small-head'>Top Batting Performers</h3>
              {(width > 768) ? (<>
                <Row>

                  <Col>
                    <CurrentSeries data={statsDataBattingMostRuns} cardtitle={'Highest Run Scorer'} urlStat={`/${pageUrl}/batting-most-runs`} />
                  </Col>
                  <Col>
                    <CurrentSeries data={statsDataBattingHighestStrikerate} titleData={statsDataBattingHighestStrikerate?.fetchSeriesStats[0]?.sStrike} dataProperty='sStrike' titleFirst={'Strike Rate'} cardtitle={'Highest Strike Rate'} urlStat={`/${pageUrl}/batting-highest-strikerate`} />
                  </Col>
                  <Col>
                    <CurrentSeries data={statsDataBattingHighestAverage} titleData={statsDataBattingHighestAverage?.fetchSeriesStats[0]?.nAverage} dataProperty='nAverage' titleFirst={'Average'} cardtitle={'Highest Average'} urlStat={`/${pageUrl}/batting-highest-average`} />
                  </Col>
                </Row>
              </>) : (<>

                <Slider nav gap={12} destroyBelow={1199} >

                  <CurrentSeries data={statsDataBattingMostRuns} cardtitle={'Highest Run Scorer'} urlStat={`/${pageUrl}/batting-most-runs`} />
                  <CurrentSeries data={statsDataBattingHighestStrikerate} titleData={statsDataBattingHighestStrikerate?.fetchSeriesStats[0]?.sStrike} dataProperty='sStrike' titleFirst={'Strike Rate'} cardtitle={'Highest Strike Rate'} urlStat={`/${pageUrl}/batting-highest-strikerate`} />
                  <CurrentSeries data={statsDataBattingHighestAverage} titleData={statsDataBattingHighestAverage?.fetchSeriesStats[0]?.nAverage} dataProperty='nAverage' titleFirst={'Average'} cardtitle={'Highest Average'} urlStat={`/${pageUrl}/batting-highest-average`} />

                </Slider >
              </>)}
              <h3 className='small-head mt-4'>Top Bowling Performers</h3>
              {
                (width > 768) ? (
                  <>
                    <Row>

                      <Col md={4}>
                        <CurrentSeries data={statsDataBowlingTopWickeTakers} titleData={statsDataBowlingBestEconomy?.fetchSeriesStats[0]?.nWickets} dataProperty='nWickets' titleFirst={'wickets'} cardtitle={'Highest Wickets'} urlStat={`/${pageUrl}/bowling-top-wicket-takers`} />
                      </Col>
                      <Col md={4}>
                        <CurrentSeries data={statsDataBowlingBestEconomy} titleData={statsDataBowlingBestEconomy?.fetchSeriesStats[0]?.nEcon} dataProperty='nEcon' titleFirst={'Economy'} cardtitle={'Top Bowling Economy'} urlStat={`/${pageUrl}/bowling-best-economy-rates`} />
                      </Col >
                      <Col md={4}>
                        <CurrentSeries data={statsDataBowlingBestAverages} titleData={statsDataBowlingBestAverages?.fetchSeriesStats[0]?.nAverage} dataProperty='nAverage' titleFirst={'Average'} cardtitle={'Bowling Average'} urlStat={`/${pageUrl}/bowling-best-averages`} />
                      </Col>
                    </Row >
                  </>) : (
                  <>

                    <Slider nav gap={12} destroyBelow={1199}>

                      <CurrentSeries data={statsDataBowlingTopWickeTakers} titleData={statsDataBowlingBestEconomy?.fetchSeriesStats[0]?.nWickets} dataProperty='nWickets' titleFirst={'wickets'} cardtitle={'Highest Wickets'} urlStat={`/${pageUrl}/bowling-top-wicket-takers`} />
                      <CurrentSeries data={statsDataBowlingBestEconomy} titleData={statsDataBowlingBestEconomy?.fetchSeriesStats[0]?.nEcon} dataProperty='nEcon' titleFirst={'Economy'} cardtitle={'Top Bowling Economy'} urlStat={`/${pageUrl}/bowling-best-economy-rates`} />
                      <CurrentSeries data={statsDataBowlingBestAverages} titleData={statsDataBowlingBestAverages?.fetchSeriesStats[0]?.nAverage} dataProperty='nAverage' titleFirst={'Average'} cardtitle={'Bowling Average'} urlStat={`/${pageUrl}/bowling-best-averages`} />

                    </Slider >
                  </>
                )
              }
              <h3 className='small-head mt-4'>Other Stats</h3>
              <Row>
                <Col xxl={4} md={6}>
                  <StatsCardTable data={cardTableDataBat} cardtitle={'Batting'} />
                </Col>
                <Col xxl={4} md={6}>
                  <StatsCardTable data={cardTableDataBwl} cardtitle={'Bowling'} />
                </Col>
                <Col xxl={4} md={6}>
                  <StatsCardTable data={cardTableDataAll} cardtitle={'Teams'} />
                </Col>
              </Row>
            </>
          ) : (
            <NoData />
          )}
        </>
      ) : (
        <>
          <StatsTable data={data}
            matchTypeData={matchTypeData}
            typeData={typeData}
            id={id} />
        </>
      )}
    </>
  )
}

Stats.propTypes = {
  data: PropTypes.object,
  typeData: PropTypes.object,
  id: PropTypes.string,
  matchTypeData: PropTypes.array,
  statsDataBattingMostRuns: PropTypes.object,
  statsDataBattingHighestStrikerate: PropTypes.object,
  statsDataBattingHighestAverage: PropTypes.object,
  seo: PropTypes.object,
  statsDataBowlingTopWickeTakers: PropTypes.object,
  statsDataBowlingBestEconomy: PropTypes.object,
  statsDataBowlingBestAverages: PropTypes.object
}

export default Stats
